import React, { Fragment, useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import { Label, ButtonToolbar, Button } from 'reactstrap';
import Select from '../../../shared/components/form/Select';
import renderCheckBoxField from '../../../shared/components/form/CheckBox';

const VaccinationFilter = (props) => {
  const {
    lastFilter,
    initialize,
    t,
    vaccines,
    classes,
    students,
    filterClick,
  } = props;

  const [filter, setFilter] = useState({
    pending: true,
    late: true,
    applied: true,
  });

  const filterChange = (field, value) => {
    const updatedFilter = { ...filter };
    updatedFilter[field] = value;
    setFilter(updatedFilter);
  };

  const filterPendingCheckChange = (evt) => {
    if (evt) {
      const updatedFilter = { ...filter };
      updatedFilter[evt.target.name] = evt.target.checked;
      filterChange('pending', evt.target.checked);
    } else {
      filterChange('pending', true);
    }
  };

  const filterLateCheckChange = (evt) => {
    if (evt) {
      const updatedFilter = { ...filter };
      updatedFilter[evt.target.name] = evt.target.checked;
      filterChange('late', evt.target.checked);
    } else {
      filterChange('late', true);
    }
  };

  const filterAppliedCheckChange = (evt) => {
    if (evt) {
      const updatedFilter = { ...filter };
      updatedFilter[evt.target.name] = evt.target.checked;
      filterChange('applied', evt.target.checked);
    } else {
      filterChange('applied', true);
    }
  };

  useEffect(() => {
    if (lastFilter) {
      setFilter(lastFilter);
      initialize(lastFilter);
    } else {
      initialize(filter);
    }
  }, []);

  return (
    <Fragment>
      <form className="form">
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('vaccination.vaccine')}
          </span>
          <div className="form__form-group-field">
            <Field
              type="text"
              component={Select}
              isMulti
              closeMenuOnSelect={false}
              placeholder={t('vaccination.vaccine')}
              options={vaccines}
              onChange={(values) => filterChange('vaccines', values)}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.classes-names')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="classes"
              type="text"
              closeMenuOnSelect={false}
              component={Select}
              isMulti
              placeholder={t('general.classes-names')}
              options={classes}
              onChange={(values) => filterChange('classes', values)}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">
            {t('general.students')}
          </span>
          <div className="form__form-group-field">
            <Field
              name="students"
              type="text"
              closeMenuOnSelect={false}
              component={Select}
              isMulti
              placeholder={t('general.students')}
              options={students}
              onChange={(values) => filterChange('students', values)}
            />
          </div>
        </div>
        <div className="form__form-group">
          <span className="form__form-group-label">{t('general.status')}</span>
        </div>
        <div className="form__form-group--3_columns">
          <div className="form__form-group">
            <div className="form__form-group-field">
              <Field
                name="pending"
                component={renderCheckBoxField}
                className="colored-click"
                onChange={filterPendingCheckChange}
              />
              <Label
                style={{ paddingRight: '5px' }}
                className="form__form-group-label"
              >
                {t('vaccination.pending')}
              </Label>
            </div>
          </div>
          <div className="form__form-group">
            <div className="form__form-group-field">
              <Field
                name="late"
                component={renderCheckBoxField}
                className="colored-click"
                onChange={filterLateCheckChange}
              />
              <Label
                style={{ paddingRight: '5px' }}
                className="form__form-group-label"
              >
                {t('vaccination.late')}
              </Label>
            </div>
          </div>
          <div className="form__form-group">
            <div className="form__form-group-field">
              <Field
                name="applied"
                component={renderCheckBoxField}
                className="colored-click"
                onChange={filterAppliedCheckChange}
              />
              <Label
                style={{ paddingRight: '5px' }}
                className="form__form-group-label"
              >
                {t('vaccination.applied')}
              </Label>
            </div>
          </div>
          <ButtonToolbar className="filter-button">
            <Button color="success" onClick={() => filterClick(filter)}>
              {t('general.filter')}
            </Button>
          </ButtonToolbar>
        </div>
      </form>
    </Fragment>
  );
};

VaccinationFilter.propTypes = {
  initialize: PropTypes.func.isRequired,
  lastFilter: PropTypes.shape(PropTypes.shape),
  filterClick: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  vaccines: PropTypes.arrayOf(PropTypes.shape).isRequired,
  classes: PropTypes.arrayOf(PropTypes.shape).isRequired,
  students: PropTypes.arrayOf(PropTypes.shape).isRequired,
};

VaccinationFilter.defaultProps = {
  lastFilter: null,
};

export default reduxForm({
  form: 'VaccinationFilter',
})(withTranslation('common')(VaccinationFilter));
